import { useHistory } from 'react-router-dom';
import { removeAuthStuffInUrl } from '../removeAuthStuffInUrl';
const parseState = (stateB64) => {
    if (!stateB64) {
        return '';
    }
    try {
        const stateString = atob(stateB64);
        const state = JSON.parse(stateString);
        return state.urlAfterAuthLanding;
    }
    catch (error) {
        //do nothing?
    }
    return '';
};
/**
 * After login completes, we need to take the state buffer from b2c, convert it,
 * and then redirect to the returnUrl it contains.
 */
export const useStateAfterLoginComplete = () => {
    const { createHref, push } = useHistory();
    return (
    /** The "state" property can be found on responses from MSAL requests to do SSO or token acquisition */
    stateB64) => {
        const urlAfterAuthLanding = parseState(stateB64);
        // If there's a baseurl set on the router,
        // we must remove that from what we push to the router
        const baseurl = createHref({ pathname: '/' });
        const withoutRouterBase = urlAfterAuthLanding.replace(baseurl, '/');
        const target = removeAuthStuffInUrl(withoutRouterBase);
        push(Object.assign(Object.assign({}, window.location), { pathname: target }));
    };
};
